<section *ngIf=" isLoaderEnabled$ | async">
    <app-page-loader-overlay>
    </app-page-loader-overlay>
</section>